export const queryKeys = {
    logBookList: 'logBookList',
    logBookGrid: 'logBookGrid',
    listPatients: 'patientsList',
    patientInfo: 'patientInfo',
    patientShareInfo: 'patientShareInfo',
    reportData: 'reportData',
    doctorInfo: 'doctorInfo',
    getShareToken: 'getShareToken',
    hypoInfo: 'hypoInfo',
    hypoList:'hypoList',
    agentList:'agentList',
    appType:'appType'

};